import { WS_EVENT_TYPES } from "@/utils/constants";
import { departmentSocketService } from "@/utils/socket/department";

export const omtkSocketService = {
  [WS_EVENT_TYPES.ORDER_ITEM_CHANGE_STATUS_REJECT_EVENT](data) {
    departmentSocketService[
      WS_EVENT_TYPES.ORDER_ITEM_CHANGE_STATUS_REJECT_EVENT
    ].call(this, data);
  },
  [WS_EVENT_TYPES.ORDER_SEND_EVENT](data) {
    data.show = true;
    data.parentClassName = "row-fade-animate";
    this.orders.unshift({});
    this.$set(this.orders, 0, data);
    this.setSuccess({ text: this.$t("addedNewOrder") });
  },
  [WS_EVENT_TYPES.ORDER_ITEM_CREATE_EVENT]() {},
};
